import { PYTHON_SERVICE_ENDPOINTS, PythonAPI } from '@buildwise/libs/services';

class PythonPostsAPI extends PythonAPI {
  public saveFilesMetaData(payload: {
    filesList: {
      documentName: string;
      documentType: string;
      documentDirectory: string;
      documentSize: number;
    }[];
    companyId: string;
    level: 'company';
    originIndicator: 'CREATE_POSTS';
  }) {
    return this.post<{
      filesList: {
        UploadUrl: string;
        companyId: string;
        createdAt: string | Date;
        createdBy: string;
        documentDirectory: string;
        documentName: string;
        documentSize: number;
        documentType: string;
        id: string;
        isDocumentUploaded: boolean;
        s3Key: string;
      }[];
    }>(PYTHON_SERVICE_ENDPOINTS.ARTICLE_CREATION_WITH_FILES, payload);
  }

  public uploadFileToS3({
    s3Url,
    file,
    uploadProgress,
  }: {
    s3Url: string;
    file: File;
    uploadProgress: (uploadedPercentage: number) => void;
  }) {
    return this.put(s3Url, file, {
      headers: { 'Content-Type': file.type },
      onUploadProgress: (e) => {
        var percentCompleted = Math.round((e.loaded * 100) / e.total);
        uploadProgress(percentCompleted);
      },
    });
  }

  public verifyUploadedFiles(payload: {
    id: string;
    fileMD5Hash: string;
    MimeType: string;
    companyId: string;
    filePath: string;
    startProcessing?: boolean;
  }) {
    return this.post(PYTHON_SERVICE_ENDPOINTS.ARTICLE_CREATION_VERIFY_FILES, payload);
  }
}

const pythonPostsAPI = new PythonPostsAPI();
export default pythonPostsAPI;
